<template>
  <div class="contain-inside">
    <QuestionAsked 
      :item="question_asked" 
      class="mt-8" 
      @selected="answer_selected"
    />
  </div>
</template>

<script>
import QuestionAsked from '@/view/components/questions/QuestionAsked.vue';

export default {
  name: 'WebBuilderSurveyRadio',
  components: {
    QuestionAsked
  },
  props: {
    columns: {
      type: Array,
      default: () => []
    }
  },
  data() { 
    return {
      question_asked: {
        id: 1,
        type: 'RADIO',
        name: 'Hur många gånger har du vandrat?',
        options: [
          {
            text: '1',
            value: 1
          },
          {
            text: 'Vill ej uppge',
            value: null
          }
        ]
      },
    }
  },
  methods: {
    answer_selected() {}
  }
};
</script>
